import queryString from "query-string";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import QueryLoading from "../components/animations/QueryLoading";
import Error from "../components/Error";
import FormWrapper from "../components/styles/FormWrapper";
import InputFormContainer from "../components/styles/InputFormContainer";
import useAxios from "axios-hooks";
import { API_URL } from "../config";

const ResetPage = (props) => {
  const router = queryString.parse(props.location.search);

  const [{ loading, error }, resetPassword] = useAxios(
    {
      url: `${API_URL}/resetPassword`,
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    if (password === confirmpassword) {
      resetPassword({
        data: {
          resetToken: router.resetToken,
          userId: router.user,
          password,
        },
      })
        .then((data) => {
          if (data) {
            localStorage.setItem("loggedIn", "true");
            props.history.push("/");
            props.refetchUser();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      alert("Passwords do not match");
    }
  };
  return (
    <>
      {loading ? (
        <QueryLoading />
      ) : (
        <InputFormContainer>
          <h2>Reset password</h2>
          <FormWrapper onSubmit={handleSubmit}>
            <p>
              <label htmlFor="password">New password</label>

              <input
                type="password"
                name="password"
                value={password}
                onChange={(event) => setpassword(event.target.value)}
              />
            </p>
            <p>
              <label htmlFor="confirmpassword">Confirm password</label>

              <input
                type="password"
                name="confirmpassword"
                value={confirmpassword}
                onChange={(event) => setconfirmpassword(event.target.value)}
              />
            </p>
            <Error error={error} />
            <button type="submit">Reset password</button>
          </FormWrapper>
        </InputFormContainer>
      )}
    </>
  );
};

export default withRouter(ResetPage);
